import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "timescalestretch"
    }}>{`timeScaleStretch`}</h1>
    <p>{`A set of parameters used when stretching audio using the Time-Scale stretch mode.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`The namespace URI is `}<a parentName="p" {...{
            "href": "http://ns.adobe.com/xmp/1.0/DynamicMedia/"
          }}>{`http://ns.adobe.com/xmp/1.0/DynamicMedia/`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The preferred namespace prefix is xmpDM`}</p>
      </li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Name`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Description`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Type`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`xmpDM:frameOverlappingPercentage`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The percentage of overlap between frames`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "../index.md#real"
            }}>{`Real`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`xmpDM:frameSize`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The splices per beat`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "../index.md#real"
            }}>{`Real`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`xmpDM:quality`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`One of high, medium or low`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Closed Choice of `}<a parentName="td" {...{
              "href": "../index.md#text"
            }}>{`Text`}</a></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      